import { useTranslation } from 'react-i18next'
import { AddAppeal } from '~/features/common/Balance/Appeal/AddAppeal'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'balances', link: '/balance/balance-histories' },
  { titleI18n: 'requests', link: '/balance/appeals' },
  { titleI18n: 'new request' },
]

export function AddAppealPage() {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('new request')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('new request')}</PageTitle>
      </Container>

      <AddAppeal />
    </PageContainer>
  )
}
